import {
  DISTRIBUTER_EDIT,
  DISTRIBUTER_PROFILE,
  FORGET_PASSWORD,
  LOGIN,
  LOGOUT,
  PORTAL_LOGIN,
  RESET_PASSWORD,
  SIGNUP,
  VERIFY_EMAIL,
  DISTRIBUTOR_IMG_LOGO,
  CREATE_NEW_PASSWORD
} from "./types";

export const login = (email, password, onSuccess, onError) => {
  return {
    type: LOGIN,
    email,
    password,
    onSuccess,
    onError,
  };
};

export const signup = (
  email,
  password,
  confirm_password,
  onSuccess,
  onError
) => {
  return {
    type: SIGNUP,
    email,
    password,
    confirm_password,
    onSuccess,
    onError,
  };
};

export const verifyEmail = (id, onSuccess, onError) => {
  return {
    type: VERIFY_EMAIL,
    id,
    onSuccess,
    onError,
  };
};

export const logout = (onSuccess, onError) => {
  return {
    type: LOGOUT,
    onSuccess,
    onError,
  };
};

export const forgetPassword = (email, onSuccess, onError) => {
  return {
    type: FORGET_PASSWORD,
    email,
    onSuccess,
    onError,
  };
};

export const resetPassword = (
  id,
  password,
  confirm_password,
  onSuccess,
  onError
) => {
  return {
    type: RESET_PASSWORD,
    id,
    password,
    confirm_password,
    onSuccess,
    onError,
  };
};

export const redirectedLogin = (token, onSuccess, onError) => {
  return {
    type: PORTAL_LOGIN,
    token,
    onSuccess,
    onError,
  };
};

export const distributorProfile = (id, onSuccess, onError) => {
  return {
    type: DISTRIBUTER_PROFILE,
    id,
    onSuccess,
    onError,
  }
}

export const distributorEdit = (data, onSuccess, onError) => {
  return {
    type: DISTRIBUTER_EDIT,
    data,
    onSuccess,
    onError,
  }
}

export const distributorLogoUpload = (image, onSuccess, onError) => {
  return {
    type: DISTRIBUTOR_IMG_LOGO,
    image,
    onSuccess,
    onError,
  }
}

export const createNewPassword = (data, onSuccess, onError) => {
  return {
    type: CREATE_NEW_PASSWORD,
    data,
    onSuccess,
    onError,
  };
}
